import type { RouteRecordRaw } from 'vue-router';
import { createRouter, createWebHistory } from 'vue-router'
import HomePage from "../views/HomePage.vue"
import ActivityPage from "../views/ActivityPage.vue"
import NotableWorksPage from "../views/NotableWorksPage.vue"
import AffiliatesPage from "../views/AffiliatesPage.vue"

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Home',
    component: HomePage,
  },
  {
    path: '/activity/:activity',
    name: 'Activity',
    component: ActivityPage,
  },
  {
    path: '/notableWorks',
    name: "Notable Works",
    component: NotableWorksPage,
  },
  {
    path: "/affiliates",
    name: "Affiliates",
    component: AffiliatesPage,
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

export default router
